import {sortWith} from '../../sortWith'
import {comparator} from './comparator'

export const createdAtComparator = <T extends {createdAt: string}>(a: T, b: T): number => comparator(a, b, 'createdAt')

export const sortWithCreatedAt = sortWith(createdAtComparator)
